import type { AtomLike, Ext } from '../core'
import { action } from '../core'
import { abortVar, wrap } from '../methods'
import type { Fn, MaybeUnsubscribe } from '../utils'
import { isAbort, noop } from '../utils'
import { withAbort } from './withAbort'
import { withCallHook } from './withChangeHook'

export let withConnectHook =
  <Target extends AtomLike>(
    cb: (target: Target) => MaybeUnsubscribe,
  ): Ext<Target> =>
  (target) => {
    const onConnect = (target.__reatom.onConnect ??= action(
      noop,
      `${target.name}.withConnectHook`,
    ).extend(withAbort()))

    onConnect.extend(
      withCallHook(async () => {
        try {
          let result = cb(target)

          if (result instanceof Promise) {
            result = await wrap(result)
          }

          if (typeof result === 'function') {
            abortVar.subscribe(() => abortVar.spawn(result as Fn))
          }
        } catch (error) {
          if (!isAbort(error)) throw error
        }
      }),
    )

    return target
  }

export let withDisconnectHook = <Target extends AtomLike>(
  cb: (target: Target) => void,
): Ext<Target> => withConnectHook((target) => () => cb(target))
